import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from '@/modules/ui';
import { InfoOutlined } from '@/modules/ui/components/Icon/InfoOutlined';

import * as felaRules from './PasskeyOnlyRole.rules';

export interface PasskeyOnlyRoleProps {
    disabled: boolean;
}

export const PasskeyOnlyRole = ({ disabled }: PasskeyOnlyRoleProps) => {
    const { css } = useFela<{ disabled: boolean }>({
        disabled,
    });

    return (
        <div className={css(felaRules.passkeyOnlyRole)}>
            <FormattedMessage id='secret.permission.passkeyOnly' />
            {disabled && (
                <Tooltip trigger={'hover'} title={<FormattedMessage id='settings.form.defaultPermission.passkeyOnly.tooltip' />}>
                    <div className={css(felaRules.tooltipButton)}>
                        <InfoOutlined />
                    </div>
                </Tooltip>
            )}
        </div>
    );
};
